var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdownright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17773 13.8555C11.2832 13.8555 13.8555 11.2832 13.8555 8.17773C13.8555 5.07227 11.2773 2.5 8.17188 2.5C5.07227 2.5 2.5 5.07227 2.5 8.17773C2.5 11.2832 5.07227 13.8555 8.17773 13.8555ZM6.37891 6.72461C6.64844 6.72461 6.82422 6.90625 6.82422 7.19922V8.1543L6.74219 9.02734L7.55078 8.1543L9.60742 6.0918C9.70117 5.99805 9.81836 5.95117 9.96484 5.95117C10.2285 5.95117 10.4102 6.12695 10.4102 6.40234C10.4102 6.52539 10.3516 6.64258 10.2637 6.73047L8.19531 8.79883L7.31641 9.61328L8.14258 9.52539H9.15039C9.4375 9.52539 9.625 9.69531 9.625 9.95898C9.625 10.2285 9.44336 10.3984 9.16211 10.3984H6.46094C6.14453 10.3984 5.94531 10.252 5.94531 9.89453V7.20508C5.94531 6.92383 6.12109 6.72461 6.37891 6.72461Z",
    fill: "#8F9397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdownright);
export default __webpack_public_path__ + "static/media/Arrow down right.203b436ca623c51bb4fad064c525d87c.svg";
export { ForwardRef as ReactComponent };